import * as React from "react";

import { styled, classNamesFunction, IconButton, IButton, ITagItemStyles } from "@fluentui/react";
import { useId } from "@fluentui/react-hooks";
import { getStyles } from "@fluentui/react/lib/components/pickers/TagPicker/TagItem.styles";
import { IBuildingItemProps, IBuildingItemStyleProps } from "./BuildingPicker.types";

const getClassNames = classNamesFunction<IBuildingItemStyleProps, ITagItemStyles>();

export const BuildingItemBase = (props: IBuildingItemProps) => {
  const {
    theme,
    styles,
    selected,
    disabled,
    enableItemFocusInDisabledPicker,
    children,
    className,
    index,
    onRemoveItem,
    removeButtonAriaLabel,
    title = typeof props.children === "string"
      ? props.children
      : `${props.item.developerAcronym} ${props.item.number} | ${props.item.address}`,
    removeButtonIconProps,
  } = props;

  const buttonRef = React.createRef<IButton>();

  const handleClick: React.MouseEventHandler<HTMLDivElement> = () => {
    buttonRef.current?.focus();
  };

  const classNames = getClassNames(styles, {
    theme: theme!,
    className,
    selected,
    disabled,
  });

  const itemId = useId();

  const disabledAttrs = enableItemFocusInDisabledPicker
    ? {
        "aria-disabled": disabled,
        tabindex: 0,
      }
    : {
        disabled,
      };

  return (
    <div data-selection-index={index} className={classNames.root} role={"listitem"} key={index} onClick={handleClick}>
      <span className={classNames.text} title={title} id={`${itemId}-text`}>
        {children}
      </span>
      <IconButton
        componentRef={buttonRef}
        id={itemId}
        onClick={onRemoveItem}
        {...disabledAttrs}
        iconProps={removeButtonIconProps ?? { iconName: "Cancel" }}
        styles={{ icon: { fontSize: "12px" } }}
        className={classNames.close}
        aria-labelledby={`${itemId}-removeLabel ${itemId}-text`}
      />
      <span id={`${itemId}-removeLabel`} hidden>
        {removeButtonAriaLabel}
      </span>
    </div>
  );
};

export const BuildingItem = styled<IBuildingItemProps, IBuildingItemStyleProps, ITagItemStyles>(
  BuildingItemBase,
  getStyles,
  undefined,
  {
    scope: "BuildingItem",
  }
);
